import styles from "./styles.module.css"

import { useState } from "react";

import Loading from "../../Loading";

import { IoTrashOutline } from "react-icons/io5";

import { doc, updateDoc } from "firebase/firestore";

import { database } from "../../../services/firebase-config";

export default function CategoryRemoveButton({ categoryId, updateTableData }) {

    const [modal, setModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    async function disableQuestion(docId) {
        setIsLoading(true);
        const documentRef = doc(database, 'categories', docId);
        await updateDoc(documentRef, { active: false })
        setModal(false);
        setIsLoading(false);
        updateTableData();
    }

    return (<>
        <button title="Desativar" className={styles.removeButton} onClick={() => { setModal(true) }}>
            <IoTrashOutline />
        </button>

        {modal &&
            <div className={styles.modalContainer}>
                <div className={styles.modalCard}>
                    {isLoading && <Loading />}
                    <h2 className={styles.modalCard__title}>Deletar</h2>
                    <p className={styles.modalCard__alert}>Tem certeza que deseja <strong>deletar</strong> este item?</p>
                    <div className={styles.modalCard__buttonsContainer}>
                        <button onClick={() => { setModal(false) }} className={styles.modalCard__closeButton}>Fechar</button>
                        <button onClick={() => { disableQuestion(categoryId) }} className={styles.modalCard__deleteButton}>Deletar</button>
                    </div>
                </div>
            </div>
        }

    </>);
}